import { Popover, PopoverContent } from "@/components/ui/popover";
import { Field, Label } from "@/components/catalyst/fieldset";
import { ReactNode } from "react";
import { Select } from "@/components/catalyst/select";
import { TableFilterButton } from "@/lib/Components/DataTable/Filters/TableFilterButton";

export type SelectFilterOption<T extends string> = {
  label: string;
  value: T;
};

export function SelectFilter<T extends string>({
  options,
  onChange,
  selected,
  label,
}: {
  options: SelectFilterOption<T>[];
  onChange: (value: T | null) => void;
  selected: NoInfer<T> | null;
  label: ReactNode;
}) {
  const selectedLabel = options.find(
    (option) => option.value === selected,
  )?.label;

  return (
    <Popover>
      <TableFilterButton
        label={label}
        selectedLabel={selectedLabel}
        numSelected={selected ? 1 : 0}
        onClear={() => {
          onChange(null);
        }}
      />

      <PopoverContent align="start">
        <Field className="relative">
          <Label>{label}</Label>
          <Select
            value={selected ?? ""}
            onChange={(e) => onChange(e.target.value as T)}
          >
            <option value="" disabled selected>
              Select an option
            </option>
            {options.map((o) => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </Select>
        </Field>
      </PopoverContent>
    </Popover>
  );
}
